import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import DashboardCard from 'components/molecules/Cards/DashboardCard/DashboardCard';

const StyledInsightsDashboardCard = styled(DashboardCard)`
  &.InsightsDashboardCard {
    padding: ${props => props.theme.spacing(2)};
    
    .DashboardCard-header {
      padding: 0 0 ${props => props.theme.spacing(1)} 0;

      .MuiCardHeader-action {
        display: flex;
        column-gap: ${props => props.theme.layout('2sp')};
        margin-right: ${props => props.theme.layout('0.5sp')};
      }
    }

    .DashboardCard-content {
      padding: 0;
      .InsightsList {
        padding: 0;
      }
    }
  }

  .DashboardCard-content {
    height: 1px;
    flex-grow: 1;
  }
  
  ${ComponentStyles}
`;

StyledInsightsDashboardCard.propTypes = {
  theme: PropTypes.object
};

export default StyledInsightsDashboardCard;
